import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { z } from "zod";

export type EditCreateFolderFormValues = z.infer<ReturnType<typeof useEditCreateFolderZodSchema>>;

export const useEditCreateFolderZodSchema = () => {
	const { t } = useTranslation();

	return useMemo(() => {
		return z.object({
			name: z.string(),
			color: z.string(),
			isReserved: z.boolean(),
			giveAccessToSubfolders: z.boolean(),
			reservedToUsers: z.array(
				z.object({
					_id: z.string(),
					id: z.string(),
					name: z.string(),
					surname: z.string(),
					email: z.string(),
					profileUrl: z.string().optional(),
					isNew: z.boolean().optional(),
					createdAt: z.string(),
					updatedAt: z.string(),
				})
			),
			reservedToTeams: z.array(
				z.object({
					id: z.string(),
					name: z.string(),
					userIds: z.array(z.string()),
					color: z.string(),
					isNew: z.boolean().optional(),
					companyId: z.string(),
					createdAt: z.string(),
					updatedAt: z.string(),
				})
			),
		});
	}, [t]);
};
